/*
 * @Author: liyihui
 * @Date:
 * @description:  接口请求访问地址 新闻中心 人才招聘
 * @Last Modified by:
 * @Last Modified time:
 */

import { gwManageGET, gwManagePOST, gwManagePUT, gwManageDEL } from './index';

// 查询公司动态（客户端）
function findCompanyDynamicByClientList(data, func) {
	gwManagePOST('findCompanyDynamicByClientList', data, func);
}
// 查询信息公开(客户端)
function findInformationDisclosureByClientList(data, func) {
	gwManagePOST('findInformationDisclosureByClientList', data, func);
}
// 获取所有招聘信息
function queryRecruitmentInfoListByClient(data, func) {
	gwManageGET('queryRecruitmentInfoListByClient', data, func);
}
// 获取招聘信息详情
function queryRecruitmentInfoByClient(data, func) {
	gwManageGET('queryRecruitmentInfoByClient/'+data.objid, data, func);
}
// 查询招聘公告(客户端)
function findRecruitmentAnnouncementByClientList(data, func) {
	gwManagePOST('findRecruitmentAnnouncementByClientList', data, func);
}


const API = {
	findCompanyDynamicByClientList,
	findInformationDisclosureByClientList,
	queryRecruitmentInfoListByClient,
	queryRecruitmentInfoByClient,
	findRecruitmentAnnouncementByClientList,
};

export default API;



// WEBPACK FOOTER //
// ./src/api/gwManage/enterprise.js